import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/style.css";
 import "bootstrap/dist/js/bootstrap.min.js"; 

const Sidebar = () => {
  return (
    <div className="col-lg-3 d-none d-lg-block sidebar">

                <div className="nav-links">
                    <Link to="/" className="active"><i className="bi bi-house"></i> Home</Link>
                    {/* <a href="#"><i className="bi bi-box-seam"></i> Delivered</a> */}
                    {/* <a href="#"><i className="bi bi-x-circle"></i> Canceled</a> */}
                    {/* <a href="#"><i className="bi bi-envelope"></i> Mails</a> */}
                </div>
            </div>
  );
};

export default Sidebar;
